import {type} from 'arktype'

import {transformProducts} from '@/models/productModel'

// This is a duplicate from the productModel.ts file which is in typebox, we should migrate to one schema
const productSchema = type({
  'id': 'string',
  'title': 'string',
  'image': 'string',
  'price': 'string|number',
  'retailer': 'string',
  'creation_time?': 'string',
  'locale?': 'string',
  'manufacturer?': 'string',
  'org_price?': 'string|number',
  'program?': 'string',
  'rating?': 'string|number',
  'rating_count?': 'string|number',
  'url?': 'string',
  'currency?': 'string',
  'out_of_stock?': 'boolean',
  'retailer_url?': 'string',
  'shipping?': 'string', // sometimes returned in store response
  'seller?': 'string', // not returned in store response
  'return?': 'string', // not returned in store response
  'shipping_information?': 'string[]', // not returned in store response
})

const sectionSchema = type({
  'products': productSchema.array(),
  'title': 'string',
  'type?': 'string',
  'scraper?': 'string',
  'username?': 'string',
  'subtitle?': 'string',
  'description?': 'string',
})

export const StoreSectionSchema = type({
  'title': 'string',
  'subtitle?': 'string',
  'products': productSchema.array(),
})

export type StoreSection = typeof StoreSectionSchema.infer

export const StoreApiResponseSchema = type({
  display: {
    'banner?': 'string',
    'banner-mobile?': 'string',
    'description': 'string',
    'logo': 'string',
    'name': 'string',
  },
  localization: {
    locale: 'string',
  },
  id: 'string',
  sections: sectionSchema.array(),
}).pipe(response => ({
  ...response,
  sections: response.sections
    .map(section => {
      const {title, subtitle, description, products} = section
      const transformedProducts = transformProducts(products)
      const finalSubtitle = subtitle ?? description

      return {
        title,
        subtitle: finalSubtitle,
        products: transformedProducts,
      }
    })
    .filter(section => section.products.length > 0),
}))

export type StoreApiResponse = typeof StoreApiResponseSchema.infer

export const StoresApiResponseSchema = type({
  'banner': 'string',
  'banner-mobile': 'string',
  'description': 'string',
  'id': 'string',
  'logo': 'string',
  'name': 'string',
}).array()

export type StoresApiResponse = typeof StoresApiResponseSchema.infer
